import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import FeaturedPage from '../components/Featured';
import { getFeaturedMatches, FeaturedFilters } from '../actions/feature';


type AppDispatch = ThunkDispatch<RootReducerState, unknown, FeatureAction>;

interface MapStateToProps {
  content: RootStockData | undefined;
}

const mapStateToProps = (state: RootReducerState): MapStateToProps => {
  return {
    content: state.featured.content
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getFeaturedMatches: (date?: string, unlock?: string, filters?: FeaturedFilters) =>
    dispatch(getFeaturedMatches(date, unlock, filters))
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type FeaturedProps = ConnectedProps<typeof connector>;
export default connector(FeaturedPage);
